import * as React from 'react';
import { observer } from 'mobx-react';
import { BurgerMenu, MenuRow } from '@ixicare/ui';
import { useStores } from '~store/utils';
import TopBar from '~components/TopBar/TopBar';

interface DashboardWrapperProps {
  children: React.ReactNode;
  routes: MenuRow[];
}

const DashboardWrapper: React.FC<DashboardWrapperProps> = observer(({ children, routes }) => {
  const { auth, sites } = useStores();

  const siteName = sites.selectedSite?.name;
  const menuRows = siteName
    ? routes.map((row) => ('siteHeader' in row ? { ...row, siteName } : row))
    : routes.filter((row) => !('siteHeader' in row));

  return (
    <div id="page-wrap-outer">
      <div className="no-print">
        <TopBar />
      </div>
      {auth.user && (
        <div className="no-print">
          <BurgerMenu routes={menuRows} />
        </div>
      )}
      <main id="page-wrap-main">{children}</main>
    </div>
  );
});

export default DashboardWrapper;
